import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './sub-nav.css';

const SubNav = ({ navItems }) => {
  const location = useLocation();
  const isDefaultActive = location.pathname === '/profile';

  return (
    <nav className="profile-subnav">
      <ul>
        {navItems.map(item => (
          <li key={item.id}>
            <NavLink
              to={`/profile/${item.path}`}
              className={({ isActive }) => 
                (isActive || (isDefaultActive && item.path === 'about')) ? 'active-profile' : 'inactive-profile'
              }
            >
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default SubNav;